import React, { useEffect } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  RichTextField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import {
  change,
  Field,
  FormSection,
  formValueSelector,
  getFormValues,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { SaveButton } from "components/Buttons"
import ColorPicker from "components/ColorPicker"
import validate from "./basicContentValidation"
import { connect } from "react-redux"
import {
  addBasicContent,
  getBasicContent,
  resetBasicContent,
  updateBasicContent,
} from "store/actions"
import ImageEditor from "components/ImageEditor"
import {
  mapApiResponseToBasicContentForm,
  mapBasicContentFormToApi,
  updatedBasicContentFormToApi,
} from "../utils"
import PropTypes from "prop-types"
import Preview from "./preview"
import { FONTS } from "constants/fonts"
import { LoadingIndicator } from "components/LoadingIndicator"

let BasicContent = props => {
  useEffect(() => {
    if (props.feature.entity_id) {
      props.getBasicContent(props.feature.entity_id)
    }
    return () => {
      props.resetBasicContent()
    }
  }, [])

  useEffect(() => {
    if (props.basicContent) {
      props.initializeForm(mapApiResponseToBasicContentForm(props.basicContent))
    }
  }, [props.basicContent])

  const handleBasicContentSubmit = data => {
    if (!props.basicContent) {
      props.addBasicContent(
        mapBasicContentFormToApi({
          ...data,
          vendorId: props.vendorId,
          userId: props.userId,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
          menu_item_id: props.feature.id,
        })
      )
    } else {
      props.updateBasicContent(
        updatedBasicContentFormToApi({
          ...data,
          vendorId: props.vendorId,
          userId: props.userId,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
          menu_item_id: props.feature.id,
        }),
        props.feature.entity_id
      )
    }
  }

  return props?.loading ? (
    <LoadingIndicator />
  ) : (
    <Card>
      <CardBody className="shadow-sm">
        <Row className="mb-3">
          <Col>
            <h3>{props.feature.label}</h3>
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Save"
              onClick={props.handleSubmit(handleBasicContentSubmit)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h4>CREATE TITLE AND SUBTITLE</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field name="title" component={TextField} label="Title" />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="subtitle"
                      component={TextField}
                      label="Subtitle"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h4>ADD IMAGE AND IMAGE CAPTION</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field
                      name="image"
                      component={ImageEditor}
                      onDelete={() =>
                        props.change(
                          "basic_content_feature_form.deleteImage",
                          true
                        )
                      }
                      label="Image"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="imageCaption"
                      component={TextField}
                      label="Image Caption"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h4>SET STYLE</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field
                      name="backgroundImage"
                      component={ImageEditor}
                      onDelete={() =>
                        props.change(
                          "basic_content_feature_form.deleteBackgroundImage",
                          true
                        )
                      }
                      label="Background Image"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="backgroundColor"
                      component={ColorPicker}
                      label="Background Color"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      className="full-width"
                      name="font"
                      fullWidth={true}
                      component={SingleSelectField}
                      options={FONTS.map(font => ({
                        value: font.value,
                        label: font.text,
                      }))}
                      label="Font Family"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="textColor"
                      component={ColorPicker}
                      label="Text Color"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h4>ADD CONTENT</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field
                      name="content"
                      component={RichTextField}
                      backgroundColor={props.backgroundColor}
                      textColor={props.textColor}
                      backgroundImage={props?.bgImage?.editedImage}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h4>ADD LINK</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field
                      name="linkText"
                      component={TextField}
                      label="Link Text"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="link"
                      component={TextField}
                      placeholder="This can be an URL(include http:// or https://), a phone number or an email address"
                      label="Link"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col xs={12}>
                    <label>Link Icon</label>
                  </Col>
                  <Col>
                    <div>
                      {props.menuIcons.map(icon => (
                        <label key={icon.id}>
                          <Field
                            name="linkIcon"
                            component="input"
                            type="radio"
                            value={icon.id}
                            style={{ position: "absolute", opacity: "0" }}
                          />
                          <img
                            src={icon.url}
                            style={
                              parseInt(props.linkIcon) === icon.id
                                ? {
                                    width: "30px",
                                    height: "auto",
                                    cursor: "pointer",
                                    margin: "4px",
                                    border: "1px solid red",
                                  }
                                : {
                                    width: "30px",
                                    height: "auto",
                                    cursor: "pointer",
                                    margin: "4px",
                                  }
                            }
                          />
                        </label>
                      ))}
                    </div>
                    <div>
                      <Field
                        name="linkIcon"
                        component={({ meta: { touched, error } }) =>
                          touched && error ? (
                            <span className={"input-error"}>{error}</span>
                          ) : (
                            false
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.handleSubmit(handleBasicContentSubmit)}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={4} className="mt-4 custom-features-preview">
            <Preview
              title={props.formValues?.title}
              subtitle={props.formValues?.subtitle}
              textColor={props.formValues?.textColor}
              bgImage={props.formValues?.backgroundImage?.editedImage}
              bgColor={props.formValues?.backgroundColor}
              content={props.formValues?.content}
              img={props.formValues?.image?.editedImage}
              imgCaption={props.formValues?.imageCaption}
              font={props?.formValues?.font}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

BasicContent = reduxForm({
  form: FORM_NAMES.BASIC_CONTENT_FEATURE,
  validate,
  initialValues: {
    backgroundColor: "#FFFFFF",
    textColor: "#000000",
  },
})(BasicContent)

const selector = formValueSelector(FORM_NAMES.BASIC_CONTENT_FEATURE)

const mapStateToProps = state => ({
  backgroundColor: selector(state, "backgroundColor"),
  textColor: selector(state, "textColor"),
  linkIcon: selector(state, "linkIcon"),
  menuIcons: state.menuFeatures.menuIcons,
  basicContent: state.BasicContent.basicContent,
  formValues: getFormValues(FORM_NAMES.BASIC_CONTENT_FEATURE)(state),
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  bgImage: selector(state, "backgroundImage"),
  loading: state.BasicContent.loading,
})

const mapDispatchToProps = dispatch => ({
  getBasicContent: values => dispatch(getBasicContent(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.BASIC_CONTENT_FEATURE, values)),
  resetBasicContent: () => dispatch(resetBasicContent()),
  change: (name, value) =>
    dispatch(change(FORM_NAMES.BASIC_CONTENT_FEATURE, `${name}`, value)),
  addBasicContent: values => dispatch(addBasicContent(values)),
  updateBasicContent: (values, id) => dispatch(updateBasicContent(values, id)),
})

BasicContent.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicContent)
